import React from 'react';
import { useSelector } from 'react-redux';
import './TermsAndConditions.css';
import Navbar from '../../Common/Navbar/Navbar';
import Footer from '../../Common/Footer/Footer';

import termsOfServiceContent from "../../Services/TermsofService";

const Terms = () => {
    const isDark = useSelector((state) => state.functionslice.value.isDark);
  return (

    <>
    <Navbar />

    <div className={`terms-container terms-content ${isDark ? 'dark-theme' : ''}`}>
      
        <header className="terms-header">
            <h1>{termsOfServiceContent.title}</h1>
        </header>

        <section className="terms-section">
            <p>
                <strong>Effective Date:</strong> {termsOfServiceContent.effectiveDate}
            </p>

            <br></br>

            {termsOfServiceContent.sections.map((section, index) => (
                <div key={index} className="term-section">
                <h2>{section.heading}</h2>
                <p style={{ whiteSpace: "pre-line" }}>
                    {section.content}
                </p>
                <br></br>
                </div>

            ))}

        </section>

    </div>

    <Footer />
    </>

  );
};

export default Terms;